import {useCustomMutation} from '@salesforce/commerce-sdk-react'

/**
 * Hook to recalculate basket for checkout
 */
export const useBasketRecalculate = () => {
    return useCustomMutation({
        options: {
            method: 'POST',
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: 'calculate-basket',
                apiName: 'basket'
            }
        },
        rawResponse: false
    })
}
